import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Persoane',
    financial_metrics: 'Indicatori financiari',
    onboarding_and_quality: 'Onboarding & Calitate',
    subscriptions: 'Abonamente curente',
    payments: 'Plăți',
    last_invoices: 'Ultimele facturi',
  },
  fields: {
    google_profile: 'Profil Google',
    owner_name: 'Nume proprietar',
    owner_phone_number: 'Telefon proprietar',
    company_phone_number: 'Telefon restaurant',
    address: 'Adresă',
    onboarding_manager: 'Manager onboarding',
    sales_manager: 'Manager vânzări',
    last_30_days_sales: 'Venituri ultimele 30 zile',
    lifetime_sales: 'Venituri totale',
    monthly_sales_other_platforms: 'Vânzări aplicații livrare',
    last_payout: 'Ultima plată',
    potential_tier: 'Scor potențial',
    current_tier: 'Scor IST',
    signed_at: 'Data închiderii',
    live_from: 'Data lansării',
    onboarding_quality_score: 'Scor calitate lansare',
    is_google_business_available: 'Google Business disponibil',
    is_smart_pricing_configured: 'Prețuri mai mici decât Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Flyer promoțional trimis',
    is_menu_fully_configured: 'Toate produsele din meniu disponibile',
    has_offers_on_competitor_platforms:
      'Restaurantul are oferte active pe Wolt, Uber, Lieferando (excepție oferta de livrare gratuită)?',
    is_instagram_story_shared: 'Story Instagram partajat cu proprietarul',
    is_order_system_connected_to_website:
      'Website Foodamigos conectat SAU buton Comandă Online adăugat pe website-ul restaurantului',
    delivery_mode: 'Șoferi',
    has_storefront: 'Website {{provider}}',
    screening_date: 'Data screening',
  },
  setup_fee: {
    title: 'Taxă de implementare',
    status: {
      [InvoiceStatus.Paid]: 'Plătit',
      [InvoiceStatus.Pending]: 'În așteptare',
      [InvoiceStatus.Processing]: 'În procesare',
      [InvoiceStatus.Refunded]: 'Rambursat',
      [InvoiceStatus.PartiallyRefunded]: 'Parțial rambursat',
      [InvoiceStatus.Failed]: 'Eșuat',
    },
  },
  labels: {
    yes: 'Da',
    no: 'Nu',
    month: 'Lună',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Activ',
    [CompanyOperationalStatus.Paused]: 'Pauzat',
    [CompanyOperationalStatus.Suspended]: 'Reziliat',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Lunar',
    [SubscriptionTerm.Annual]: 'Anual',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Șoferi proprii',
    [DeliveryMode.External]: 'Șoferi {{provider}}',
  },
  buttons: {
    view_details: 'Vezi detalii',
    open: 'Deschide',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
